import { render, staticRenderFns } from "./TicketsKeywords.vue?vue&type=template&id=22e334ae&scoped=true"
import script from "./TicketsKeywords.vue?vue&type=script&lang=js"
export * from "./TicketsKeywords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e334ae",
  null
  
)

export default component.exports